module.exports = __webpack_public_path__ + "img/opera.31c94a0d.png";